import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { Box } from '@eatclubcode/ec-component-library';
import { useHistory } from 'react-router-dom';
import { PrimaryButton } from '../../button/PrimaryButton';
import { Modal } from '../../Modal';

const HolidayHoursModal = ({ isOpen, onClose }) => {
  const theme = useTheme();
  const breakpointSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const history = useHistory();

  return (
    <Modal
      heading='Happy holidays from EatClub! Let’s take a moment to update your opening hours.'
      isLoading={false}
      isOpen={isOpen}
      showCloseButton={false}
      hideFooter
      onConfirm={() => {
        history.push('/profile/holiday-hours');
        onClose();
      }}
      inputStyle={{
        button: { backgroundColor: '#FAD14C', color: theme.colors.charcoalTransparent },
      }}
    >
      <Box>Please adapt your hours and offer status.</Box>

      <Box
        style={{
          display: 'flex',
          width: '100%',
          gap: '20px',
          justifyContent: 'flex-end',
          paddingTop: '40px',
        }}
      >
        <PrimaryButton
          onClick={() => {
            history.push('/profile/holiday-hours');
            onClose();
          }}
          fullWidth={breakpointSmDown}
          color='secondary'
          variant='contained'
          size='large'
          style={{ button: { height: '44px', fontWeight: '500' } }}
        >
          Review holiday hours
        </PrimaryButton>
      </Box>
    </Modal>
  );
};

HolidayHoursModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default HolidayHoursModal;
